<template>
  <div class="card shadow-bg">
    <div class="card-header">
      <h3 class="mb-0">Summary</h3>
    </div>
    <div class="card-body">
      <div class="text-center">
        <div class="col-12">
          <div class="h1">Referrals</div>
          <div class="display-3 text-dark">{{ referralCount }}</div>
        </div>
        <div class="col-12 text-dark">
          <div class="h1">Fees Earned</div>
          <div class="display-3">${{ referralFees.toFixed(2) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferralSummary',
  data() {
    return {
      referralCount: 0,
      referralFees: 0
    }
  },
  props: {
    referrals: Array
  },
  beforeMount() {
    const uniques = [...new Set(this.referrals.map((i) => i.id))]
    const fees = this.referrals.map((i) => i.event_fee)
    this.referralCount = uniques.length
    this.referralFees = fees.length ? fees.reduce((a, b) => a + b) : 0
  }
}
</script>

<style scoped></style>
